import { Info } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import MyTable from '../../../../../components/MyTable';
import { AuthStore } from '../../../../../store/UserStore';
import { base_url } from '../../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../../utils/MyEncryption';

const Adendum = (props) => {
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const logOut = AuthStore((state) => state.logOut)
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    useEffect(() => {
        console.log(props);
        if (props.noKontrak !== "") {
            requestData(props.noKontrak);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const requestData = (params) => {
        setTableLoading(true)
        console.log(params);
        axios.get(
            base_url + '/bnd/kontrak/adendum/' + params,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                const data = response.data;
                setTableData(data)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setTableLoading(false)
            })
    }

    const columns = [
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            filterable: false,
            hideable: false,
            // type: "number",
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            minWidth: 150,
            renderCell: (params) => {

                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Lihat Data">
                            <IconButton aria-label="confirm" color='success' component={Link} to="/admin/kontrak/adendum-detail" state={{ adendum: params.row, kontrak: props.kontrak }}>
                                <Info />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            },
        },
        {
            field: 'no_adendum',
            headerName: 'Nomor Adendum',
            minWidth: 230
        },
        {
            field: 'tgl_adendum',
            headerName: 'Tanggal Adendum',
            minWidth: 230
        },
        {
            field: 'jumlah_kontrak',
            headerName: 'Jumlah Kontrak',
            minWidth: 230,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.jumlah_kontrak);
            }
        },
        {
            field: 'tgl_mulai',
            headerName: 'Waktu Pengerjaan',
            renderCell: (params) => {
                return (
                    params.row.tgl_mulai + " s/d " + params.row.tgl_selesai
                )
            },
            minWidth: 230
        },
    ];

    return (
        <MyTable
            rows={tableData}
            columns={columns}
            row_id={(row) => row.no_adendum}
            isLoading={tableLoading}
        />
    )
}

export default Adendum